module.exports = __webpack_public_path__ + "static/media/users_active.f233bc10.svg";